import { BaseTableRow, getHeaderName, TableProps, TableState } from "@/types";
import { FormControlLabel, Radio } from "@mui/material";
import { SyntheticEvent } from "react";
import { Table } from "./Table";

interface VacancyTableRow extends BaseTableRow {
  jobId: string;
  fullName: string;
  jobTitle: string;
  numberOfTeamMembers: number;
  manager: {
    fullName: string;
    jobTitle: string;
  };
}

interface VacancyTableProps extends TableProps<VacancyTableRow> {
  selected?: VacancyTableRow;
}

interface VacancyTableState extends TableState {
  selectedVacancy?: VacancyTableRow;
}

export class VacancyTable extends Table<VacancyTableRow, VacancyTableProps, VacancyTableState> {
  static columns = {
    name: {
      field: "name",
      label: "tableColumns.name"
    },
    select: {
      field: "name",
      label: "tableColumns.yourSelection"
    },
    reportsTo: {
      field: "reportsTo",
      label: "tableColumns.reportsTo"
    },
    reports: {
      field: "reports",
      label: "tableColumns.reports"
    }
  };

  static defaultProps = {
    ...Table.defaultProps,
    columns: [
      { type: VacancyTable.columns.select },
      { type: VacancyTable.columns.reportsTo },
      { type: VacancyTable.columns.reports }
    ],
    noRowsMessage: "No rows",
    rowHasAction: false,
    selectable: true
  };

  constructor(props: VacancyTableProps) {
    super(props);

    this.state = {
      ...this.state,
      sortModel: this.props.sortModel
        ? this.props.sortModel
        : [
            {
              field: "name",
              sort: "desc"
            }
          ],
      selectedVacancy: props.selected
    };
  }

  getRowId(a: VacancyTableRow) {
    return this.tableId + "_" + a.jobId;
  }

  onVacancySelect(e: SyntheticEvent, selectedVacancy: VacancyTableRow) {
    const { onVacancySelect } = this.props;
    this.setState({ selectedVacancy: selectedVacancy });
    if (onVacancySelect) onVacancySelect(e, selectedVacancy);
  }

  initColumns() {
    const { columns, sortable } = this.props;

    this.columns = [];

    if (!columns) return;

    columns?.forEach((c) => {
      if (this.hasColumn(c)) {
        if (c.type === VacancyTable.columns.name)
          this.columns.push({
            field: "name",
            headerName: getHeaderName(c, this.props.translate),
            sortable: sortable,
            width: 200,
            filterable: false,
            disableReorder: true,
            valueGetter: (_value, row) => row.fullName
          });

        if (c.type === VacancyTable.columns.select)
          this.columns.push({
            field: "name",
            headerName: getHeaderName(c, this.props.translate),
            sortable: sortable,
            width: 200,
            filterable: false,
            disableReorder: true,
            valueGetter: (_value, row) => row.fullName,
            renderCell: (params) => (
              <FormControlLabel
                disableTypography={true}
                className='klayo_vacancytable_select'
                value={params.row.jobId}
                onChange={(e) => this.onVacancySelect(e, params.row)}
                checked={
                  this.state.selectedVacancy
                    ? this.state.selectedVacancy.jobId === params.row.jobId
                    : false
                }
                control={<Radio />}
                label={params.row.fullName}
              />
            )
          });

        if (c.type === VacancyTable.columns.reports)
          this.columns.push({
            field: "reports",
            sortable: sortable,
            headerName: getHeaderName(c, this.props.translate),
            flex: 1,
            filterable: false,
            disableReorder: true,
            width: 50,
            type: "number",
            valueGetter: (_value, row) => (row && !row.isCreatable ? row.numberOfTeamMembers : "")
          });

        if (c.type === VacancyTable.columns.reportsTo)
          this.columns.push({
            field: "reportsTo",
            sortable: sortable,
            headerName: getHeaderName(c, this.props.translate),
            flex: 1,
            filterable: false,
            disableReorder: true,
            valueGetter: (_value, row) => (row.manager ? row.manager.fullName : ""),
            renderCell: (params) =>
              params.row.manager ? (
                <div className='klayo_employeetable_pic klayo_employeetable_picname'>
                  <div>
                    <div className='klayo_employeetable_name'>{params.row.manager.fullName}</div>
                    <div className='klayo_employeetable_job'>{params.row.manager.jobTitle}</div>
                  </div>
                </div>
              ) : params.row.isCreatable ? (
                ""
              ) : (
                "Unassigned"
              )
          });
      }
    });
  }
}
